// import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
// import { type IPaymentSourceType } from "./types";

// /**
//  * Initial state
//  * sourceTypeId: string;
//   sourceType: "salesAndPromotion" | "referral" | "direct";
//   sourceCode: string;
//   discountedPrice: number;
//   actualPrice: number;
//  */
// const initialState: IPaymentSourceType = {
//   isValid: false,
//   sourceTypeId: null,
//   sourceType: "direct",
//   sourceCode: null,
//   discount: null,
//   discountedPrice: null,
//   originalPrice: 20,
// };

// const paymentSourceTypeSlice = createSlice({
//   name: "paymentSourceType",
//   initialState,
//   reducers: {
//     setPaymentSourceType: (
//       state,
//       action: PayloadAction<IPaymentSourceType>,
//     ) => {
//       state.sourceTypeId = action.payload.sourceTypeId;
//       state.sourceType = action.payload.sourceType;
//       state.sourceCode = action.payload.sourceCode;
//       state.discountedPrice = action.payload.discountedPrice;
//       state.originalPrice = action.payload.originalPrice;
//       state.discount = action.payload.discount;
//     },
//     resetPaymentSourceType: (state) => {
//       state.sourceTypeId = null;
//       state.sourceType = null;
//       state.sourceCode = null;
//       state.discountedPrice = null;
//       state.discount = null;
//     },
//   },
// });

// // Export actions
// export const { setPaymentSourceType, resetPaymentSourceType } =
//   paymentSourceTypeSlice.actions;
// export default paymentSourceTypeSlice.reducer;

// ============================================================================
// DESTINATION:  src/store/slices/paymentSourceType/paymentSourceTypeSlice.ts
// ACTION:       REPLACE your existing file
// ============================================================================

/**
 * paymentSourceType slice — the discount / referral context.
 *
 * ============================================================================
 * WHAT CHANGED FROM YOURS
 * ============================================================================
 *   ~ resetPaymentSourceType — FIXED. It set sourceType to null, but the type is
 *     "salesAndPromotion" | "referral" | "direct" (no null), and the initial
 *     state is "direct". Resetting to null was a type violation AND left the
 *     wrong baseline.
 *   ~ resetPaymentSourceType now also resets originalPrice back to 20.
 * Everything else is your file.
 */

import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type IPaymentSourceType } from "./types";

const initialState: IPaymentSourceType = {
  isValid: false,
  sourceTypeId: null,
  sourceType: "direct",
  sourceCode: null,
  discount: null,
  discountedPrice: null,
  originalPrice: 20,
};

const paymentSourceTypeSlice = createSlice({
  name: "paymentSourceType",
  initialState,
  reducers: {
    setPaymentSourceType: (
      state,
      action: PayloadAction<IPaymentSourceType>,
    ) => {
      state.isValid = action.payload.isValid;
      state.sourceTypeId = action.payload.sourceTypeId;
      state.sourceType = action.payload.sourceType;
      state.sourceCode = action.payload.sourceCode;
      state.discountedPrice = action.payload.discountedPrice;
      state.originalPrice = action.payload.originalPrice;
      state.discount = action.payload.discount;
    },

    /**
     * ▼ FIXED. Yours:
     *     state.sourceType = null;   // type is '...|"direct"', has no null
     *
     * Reset to the SAME baseline as initialState, or the next login inherits a
     * half-reset object: a stale originalPrice, a sourceType the type system
     * says cannot exist. Resetting to "direct" / 20 / false is the real "no
     * discount" state.
     */
    resetPaymentSourceType: (state) => {
      state.isValid = false;
      state.sourceTypeId = null;
      state.sourceType = "direct";
      state.sourceCode = null;
      state.discount = null;
      state.discountedPrice = null;
      state.originalPrice = 20;
    },
  },
});

export const { setPaymentSourceType, resetPaymentSourceType } =
  paymentSourceTypeSlice.actions;

export default paymentSourceTypeSlice.reducer;
